export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_971_ALL_AREAS': 'All Areas',
    '_826_ALL_PEERGROUPS': 'All PeerGroups',
    '_970_ALL_REGIONS': 'All Regions',
    '_825_ALL_SITES': 'All Sites',
    '_827_ALL_SUPERGROUPS': 'All SuperGroups',
    '_148_AREA': 'Area',
    '_821_CATEGORY': 'Path Category',
    '_4106_CURRENT_ACTUAL': 'Current Actual',
    '_4153_CURRENT_GAP_FROM_FULL_PERIOD_TARGET': 'Current gap from full period target',
    '_4156_CURRENT_RESULTS_ACHIEVED_PERIOD_TO_DATE': 'Current results achieved period to date',
    '_202_DAILY': 'Daily',
    '_709_DATE_RANGE': 'Date Range',
    '_830_DAY': 'Day',
    '_822_DRILL_PATH': 'Drill Path',
    '_4151_EXPECTED_FULL_PERIOD_RESULTS_BASED_ON_CURRENT_ACTUAL_TREND': 'Expected full period results based on current actual trend',
    '_4154_EXPECTED_PERCENT_TO_TARGET_RESULTS_BASED_ON_CURRENT_ACTUAL_TREND': 'Expected percent to target results based on current actual trend',
    '_4152_FULL_PERIOD_TARGET': 'Full period target',
    '_4103_GAP': 'Gap',
    '_832_MARKET': 'Market',
    '_828_MONTH': 'Month',
    '_204_MONTHLY': 'Monthly',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_977_NONE_SELECTED': 'Rapid IVR Surveys',
    '_824_PEERGROUP': 'PeerGroup',
    '_4102_PERIOD_TARGET': 'Period Target',
    '_4104_PROJECTED___TO_TARGET': 'Projected % to Target',
    '_4101_PROJECTED_RESULT': 'Projected Result',
    '_201_QUARTER': 'Quarter',
    '_205_QUARTERLY': 'Quarterly',
    '_823_REFRESH': 'Refresh',
    '_4201_REFRESH_THE_RADIALS_AND_TIMELINE_TO_THIS_HIERARCHY_LEVEL__SCROLL_TO_RADIALS': 'Refresh the radials and timeline to this hierarchy level. Scroll to radials',
    '_4202_REFRESH_THE_RADIALS_AND_TIMELINE_TO_THIS_HIERARCHY_LEVEL__SCROLL_TO_TIMELINE': 'Refresh the radials and timeline to this hierarchy level. Scroll to timeline',
    '_149_REGION': 'Region',
    '_833_SELECT_A_PEERGROUP': 'Select a PeerGroup',
    '_974_SELECT_A_REGION': 'Select a Region',
    '_652_SELECT_A_SITE': 'Select a Site',
    '_834_SELECT_A_SUPERGROUP': 'Select a SuperGroup',
    '_976_SELECT_AN_AREA': 'Select an Area',
    '_4130_SHOW_ALL': 'Show all',
    '_4133_SHOW_GAP': 'Show gap',
    '_4131_SHOW_PROJECTION': 'Show projection',
    '_4134_SHOW_TARGET__': 'Show target %',
    '_831_SHOW_TARGETS': 'Show targets',
    '_64_SITE': 'Site',
    '_7113_SUBCATEGORY': 'SubCategory',
    '_67_SUPERGROUP': 'SuperGroup',
    '_829_WEEK': 'Week',
    '_203_WEEKLY': 'Weekly',
    '_646_YYYY_MM_DD': 'yyyy-mm-dd',
    '_994_SELECT_ALL': 'Select all'
};
